import { ActionIcon, Divider, Drawer, Text, DrawerRootProps } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react';

interface DrawerBoxProps {
    title?: string;
    titleDivider?: boolean;
    withTitle?: boolean;
    withCloseButton?: boolean;
    position?: DrawerRootProps['position'];
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

function DrawerBox({
    title,
    titleDivider,
    withTitle,
    withCloseButton,
    position,
    isOpen,
    onClose,
    children
}: DrawerBoxProps) {
    return (
        <Drawer.Root
            opened={isOpen}
            onClose={onClose}
            position={position}
            size="lg"
        >
            <Drawer.Overlay />
            <Drawer.Content>
                <Drawer.Header>
                    <Drawer.Title>
                        {withTitle &&
                            <Text fw={500} fz="1rem">{title}</Text>
                        }
                    </Drawer.Title>

                    {withCloseButton &&
                        <ActionIcon className="unify-action-icon-subtle" w={26} h={26} onClick={onClose}>
                            <IconX size="1rem" />
                        </ActionIcon>
                    }
                </Drawer.Header>

                {titleDivider && <Divider mb="sm" />}

                <Drawer.Body>
                    {children}
                </Drawer.Body>
            </Drawer.Content>
        </Drawer.Root>
    )
};

export default DrawerBox;